import React from 'react';

class DvdIcon extends React.Component {
  render() {
    return (
      <svg
        width="80"
        height="80"
        viewBox="0 0 80 80"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_254_1508)">
          <g filter="url(#filter0_d_254_1508)">
            <path
              d="M27.28 51.8079H12.372C12.1666 51.8079 12 51.9744 12 52.1799V54.4979C12 54.7033 12.1666 54.8699 12.372 54.8699H27.28C27.4855 54.8699 27.652 54.7033 27.652 54.4979V52.1799C27.652 51.9744 27.4855 51.8079 27.28 51.8079Z"
              fill="#E0DDDA"
            />
            <path
              d="M27.2822 55.6698H12.3722C11.7262 55.6698 11.2002 55.1438 11.2002 54.4978V52.1779C11.2002 51.5319 11.7262 51.0059 12.3722 51.0059H27.2822C27.9282 51.0059 28.4542 51.5319 28.4542 52.1779V54.4978C28.4542 55.1438 27.9282 55.6698 27.2822 55.6698ZM12.8002 54.0699H26.8522V52.6079H12.8002V54.0699Z"
              fill="#84827E"
            />
            <path
              d="M67.628 51.74H52.372C52.1665 51.74 52 51.9065 52 52.112V54.498C52 54.7034 52.1665 54.87 52.372 54.87H67.628C67.8335 54.87 68 54.7034 68 54.498V52.112C68 51.9065 67.8335 51.74 67.628 51.74Z"
              fill="#E0DDDA"
            />
            <path
              d="M67.6282 55.67H52.3702C51.7242 55.67 51.1982 55.144 51.1982 54.498V52.11C51.1982 51.464 51.7242 50.938 52.3702 50.938H67.6282C68.2742 50.938 68.8002 51.464 68.8002 52.11V54.498C68.8002 55.144 68.2742 55.67 67.6282 55.67ZM52.8002 54.07H67.2002V52.54H52.8002V54.07Z"
              fill="#84827E"
            />
            <path
              d="M74.4 24.9399H5.6C4.71634 24.9399 4 25.6563 4 26.5399V50.1399C4 51.0236 4.71634 51.7399 5.6 51.7399H74.4C75.2837 51.7399 76 51.0236 76 50.1399V26.5399C76 25.6563 75.2837 24.9399 74.4 24.9399Z"
              fill="#F7F4F1"
            />
            <path
              d="M74.4002 52.5399H5.6002C4.2762 52.5399 3.2002 51.4639 3.2002 50.1399V26.5399C3.2002 25.2159 4.2762 24.1399 5.6002 24.1399H74.4002C75.7242 24.1399 76.8002 25.2159 76.8002 26.5399V50.1399C76.8002 51.4639 75.7242 52.5399 74.4002 52.5399ZM5.6002 25.7399C5.1582 25.7399 4.8002 26.0979 4.8002 26.5399V50.1399C4.8002 50.5819 5.1582 50.9399 5.6002 50.9399H74.4002C74.8422 50.9399 75.2002 50.5819 75.2002 50.1399V26.5399C75.2002 26.0979 74.8422 25.7399 74.4002 25.7399H5.6002Z"
              fill="#84827E"
            />
            <path
              d="M57.27 39.6121H22.73C21.2223 39.6121 20 40.8343 20 42.3421C20 43.8498 21.2223 45.072 22.73 45.072H57.27C58.7777 45.072 60 43.8498 60 42.3421C60 40.8343 58.7777 39.6121 57.27 39.6121Z"
              fill="#83827F"
            />
            <path
              d="M57.2702 45.874H22.7302C20.7842 45.874 19.2002 44.29 19.2002 42.344C19.2002 40.398 20.7842 38.814 22.7302 38.814H57.2702C59.2162 38.814 60.8002 40.398 60.8002 42.344C60.8002 44.29 59.2162 45.874 57.2702 45.874ZM22.7302 40.414C21.6662 40.414 20.8002 41.28 20.8002 42.344C20.8002 43.408 21.6662 44.274 22.7302 44.274H57.2702C58.3342 44.274 59.2002 43.408 59.2002 42.344C59.2002 41.28 58.3342 40.414 57.2702 40.414H22.7302V40.414Z"
              fill="#83827F"
            />
            <path
              d="M58 41.4299C58 51.3719 49.942 59.4299 40 59.4299C30.058 59.4299 22 51.3719 22 41.4299H58V41.4299Z"
              fill="url(#paint0_linear_254_1508)"
            />
            <path
              d="M45.376 41.4299C45.376 44.3999 42.968 46.8059 40 46.8059C37.032 46.8059 34.624 44.3979 34.624 41.4299H45.378H45.376Z"
              fill="white"
            />
            <path
              d="M21.2002 40.6299V41.4299C21.2002 51.7959 29.6342 60.2299 40.0002 60.2299C50.3662 60.2299 58.8002 51.7959 58.8002 41.4299V40.6299H21.2002V40.6299ZM40.0002 58.6299C30.7842 58.6299 23.2382 51.3439 22.8182 42.2299H25.4242C25.7502 47.9699 29.5522 52.8859 35.0962 54.6099C35.1762 54.6339 35.2542 54.6459 35.3342 54.6459C35.6762 54.6459 35.9922 54.4259 36.0982 54.0839C36.2302 53.6619 35.9942 53.2139 35.5722 53.0819C30.7022 51.5679 27.3522 47.2639 27.0282 42.2299H30.0362C30.2582 44.9639 31.6142 47.4399 33.8402 49.1099C33.9842 49.2179 34.1522 49.2699 34.3202 49.2699C34.5622 49.2699 34.8042 49.1599 34.9602 48.9499C35.2262 48.5959 35.1542 48.0959 34.8002 47.8299C32.9822 46.4639 31.8582 44.4539 31.6402 42.2279H57.1802C56.7602 51.3419 49.2142 58.6279 39.9982 58.6279L40.0002 58.6299Z"
              fill="#83837F"
            />
            <path
              d="M11.2 34.5299C12.415 34.5299 13.4 33.5449 13.4 32.3299C13.4 31.1149 12.415 30.1299 11.2 30.1299C9.98497 30.1299 9 31.1149 9 32.3299C9 33.5449 9.98497 34.5299 11.2 34.5299Z"
              fill="#83827F"
            />
            <path
              d="M18.2 34.5299C19.415 34.5299 20.4 33.5449 20.4 32.3299C20.4 31.1149 19.415 30.1299 18.2 30.1299C16.985 30.1299 16 31.1149 16 32.3299C16 33.5449 16.985 34.5299 18.2 34.5299Z"
              fill="#83827F"
            />
            <path
              d="M68.8002 30.1299H60.4002C59.1852 30.1299 58.2002 31.1149 58.2002 32.3299C58.2002 33.5449 59.1852 34.5299 60.4002 34.5299H68.8002C70.0152 34.5299 71.0002 33.5449 71.0002 32.3299C71.0002 31.1149 70.0152 30.1299 68.8002 30.1299Z"
              fill="#83827F"
            />
          </g>
        </g>
        <defs>
          <filter
            id="filter0_d_254_1508"
            x="1.8002"
            y="22.7399"
            width="79.5996"
            height="42.0901"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dx="1.6" dy="1.6" />
            <feGaussianBlur stdDeviation="1.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow_254_1508"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow_254_1508"
              result="shape"
            />
          </filter>
          <linearGradient
            id="paint0_linear_254_1508"
            x1="27.0634"
            y1="43.0399"
            x2="36.099"
            y2="63.7686"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#82D1AD" />
            <stop offset="1" stopColor="#00A872" />
          </linearGradient>
          <clipPath id="clip0_254_1508">
            <rect width="80" height="80" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  }
}

export default DvdIcon;
